import React from "react";
import PublicLegalLayout from "./PublicLegalLayout";
import {
  ABOUT_PARAGRAPHS,
  ABOUT_FEATURES,
  PRO_UNLOCKS,
  SUPPORT_EMAIL,
  SUPPORT_MAILTO,
} from "../../lib/legalCopy";

/**
 * Public marketing/“What is TipLingo?” page. Served from the no-auth
 * `/about` route so Stripe reviewers can verify product description,
 * what is being sold, and how to contact support.
 */
export default function AboutPage() {
  return (
    <PublicLegalLayout title="About TipLingo">
      <section
        data-testid="about-intro"
        className="bg-white rounded-3xl shadow-soft border border-navy/5 p-6 sm:p-7 space-y-4"
      >
        {ABOUT_PARAGRAPHS.map((p, i) => (
          <p key={i} data-testid={`about-paragraph-${i}`}>
            {p}
          </p>
        ))}
      </section>

      <section
        data-testid="about-features"
        className="bg-white rounded-3xl shadow-soft border border-navy/5 p-6 sm:p-7"
      >
        <h2 className="font-jakarta font-extrabold text-xl text-navy mb-3">
          TipLingo includes
        </h2>
        <ul className="space-y-2 text-navy">
          {ABOUT_FEATURES.map((f) => (
            <li key={f} className="flex items-start gap-2.5">
              <span
                aria-hidden
                className="mt-2 w-1.5 h-1.5 rounded-full bg-orange shrink-0"
              />
              <span>{f}</span>
            </li>
          ))}
        </ul>
      </section>

      <section
        data-testid="about-pro-unlocks"
        className="bg-white rounded-3xl shadow-soft border border-navy/5 p-6 sm:p-7"
      >
        <h2 className="font-jakarta font-extrabold text-xl text-navy mb-3">
          What does Pro unlock?
        </h2>
        <p>{PRO_UNLOCKS}</p>
      </section>

      <section
        data-testid="about-contact"
        className="bg-navy text-white rounded-3xl shadow-deep p-6 sm:p-7"
      >
        <h2 className="font-jakarta font-extrabold text-xl mb-2">
          Talk to a real human
        </h2>
        <p className="text-white/80 text-sm mb-4">
          Questions, feedback, or bug reports — we read every message and
          usually reply within one business day.
        </p>
        <a
          href={SUPPORT_MAILTO}
          data-testid="about-support-mailto"
          className="inline-flex items-center justify-center rounded-full bg-orange hover:bg-orange-hover text-white font-jakarta font-extrabold text-sm px-5 py-3"
        >
          Email {SUPPORT_EMAIL}
        </a>
      </section>
    </PublicLegalLayout>
  );
}
